import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * StepHeader — shared numbered step header for multi-step flows (e.g. the
 * Configurations / training-setup wizard). Rounded gradient badge + uppercase
 * "STEP N" kicker + title/subtitle. Purely presentational.
 *
 * Props: number, title, subtitle, kicker?, action? (right-aligned node), sx?
 */
const StepHeader = ({ number, title, subtitle, kicker, action, sx = {} }) => (
  <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, mb: 2, ...sx }}>
    <Box
      sx={{
        position: "relative",
        width: 32,
        height: 32,
        borderRadius: "10px",
        background: "linear-gradient(135deg, #0087B4 0%, #1B365D 100%)",
        color: "#ffffff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "0.8125rem",
        fontWeight: 700,
        fontFamily: "var(--fx-font-mono)",
        flexShrink: 0,
        boxShadow: "0 4px 10px rgba(0, 135, 180, 0.25)",
        "&::after": {
          content: '""',
          position: "absolute",
          inset: -3,
          borderRadius: "13px",
          border: "1px solid rgba(0, 135, 180, 0.20)",
        },
      }}
    >
      {number}
    </Box>
    <Box sx={{ minWidth: 0, flex: 1, pt: 0.25 }}>
      <Typography
        sx={{
          color: "var(--fx-text-muted)",
          fontSize: "0.625rem",
          fontWeight: 700,
          letterSpacing: "0.1em",
          textTransform: "uppercase",
          lineHeight: 1,
          mb: 0.4,
        }}
      >
        {kicker || `Step ${number}`}
      </Typography>
      <Typography sx={{ color: "var(--fx-text-primary)", fontWeight: 700, fontSize: "1rem", lineHeight: 1.2, letterSpacing: "-0.01em" }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography sx={{ color: "var(--fx-text-secondary)", fontSize: "0.8125rem", mt: 0.4, lineHeight: 1.5, maxWidth: 620 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
    {action && <Box sx={{ flexShrink: 0, pt: 0.25 }}>{action}</Box>}
  </Box>
);

export default StepHeader;
